import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./pagination.html";
import { i18nStore, WireI18n } from '~/modules/stores/i18nStore';
class Pagination extends LightningElement {
  constructor(...args) {
    super(...args);
    this._pages = void 0;
  }
  set pages(data) {
    this._pages = data.map(page => ({
      url: page.url,
      index: page.index,
      isCurrent: page.isCurrent,
      ariaLabel: i18nStore.getState().i18n.learn.pageLinkAriaLabel({
        PAGE_NUMBER: page.index
      })
    }));
  }
  get pages() {
    return this._pages;
  }
  i18nCallback(i18n) {
    this.labels = i18n.learn;
  }
  handlePageClick(event) {
    // Prevent default browser navigation on click
    event.preventDefault();
    const pageChangeEvent = new CustomEvent('learnpagechange', {
      detail: {
        pageUrl: event.target.href
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(pageChangeEvent);
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Pagination, {
  publicProps: {
    pages: {
      config: 3
    }
  },
  track: {
    _pages: 1
  },
  wire: {
    i18nCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(Pagination, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;